/* BDG Popup — 8º Aniversario · Tarjeta dorada raspable + burbuja persistente */
(function () {
  'use strict';

  var KEY = 'bdg_aniv_seen';
  var BKEY = 'bdg_aniv_bubble';
  var PKEY = 'bdg_aniv_purchased';
  var AKEY = 'bdg_aniv_armed';
  var HKEY = 'bdg_aniv_haditems';
  var DELAY_MS = 3500;
  var DISMISS_DAYS = 7;
  var BUBBLE_MS = 3650 * 24 * 60 * 60 * 1000; /* la burbuja persiste hasta comprar (~respaldo 10 anios) */
  var EXCLUDED = ['/cart', '/checkout', '/account', '/challenge', '/password'];

  /* Klaviyo — alta del lead en la lista Newsletter (BDG FAM) */
  var KLAVIYO_COMPANY = 'Q72C8S';
  var KLAVIYO_LIST = 'MBUrA6';

  /* Cupón fijo por nivel de descuento. Estos códigos DEBEN existir en Shopify
     (Descuentos) con su límite de uso. Cambia los valores si usas otros nombres. */
  var CODES = { 30: 'BDG8-30', 25: 'BDG8-25', 20: 'BDG8-20', 15: 'BDG8-15', 10: 'BDG8-10' };

  /* Distribución escalonada · descuento promedio real ~16% */
  var D = [
    { d: 30, w: 5,  m: 'El gran premio. Casi nadie llega aquí.' },
    { d: 25, w: 8,  m: 'Qué suerte la tuya.' },
    { d: 20, w: 10, m: 'Un regalo precioso.' },
    { d: 20, w: 10, m: 'Un regalo precioso.' },
    { d: 15, w: 17, m: 'Tu detalle de aniversario.' },
    { d: 15, w: 17, m: 'Tu detalle de aniversario.' },
    { d: 15, w: 13, m: 'Tu detalle de aniversario.' },
    { d: 10, w: 20, m: 'Un mimo para empezar.' }
  ];
  function pick() { var r = Math.random() * 100, a = 0; for (var i = 0; i < D.length; i++) { a += D[i].w; if (r <= a) return D[i]; } return D[D.length - 1]; }
  function msgFor(d) { for (var i = 0; i < D.length; i++) { if (D[i].d === d) return D[i].m; } return ''; }

  function seen() {
    try { var v = localStorage.getItem(KEY); if (!v) return false; return (Date.now() - parseInt(v, 10)) < DISMISS_DAYS * 864e5; }
    catch (e) { return false; }
  }
  function mark() { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} }
  function forced() { return window.location.search.indexOf('bdg_aniv=1') !== -1; }
  function pathOk() { var p = window.location.pathname.toLowerCase(); for (var i = 0; i < EXCLUDED.length; i++) { if (p.indexOf(EXCLUDED[i]) !== -1) return false; } return true; }
  function shouldShow() { if (!pathOk()) return false; return !seen(); }

  /* Compra detectada: la burbuja desaparece para siempre una vez marcado. */
  function purchased() {
    try { if (localStorage.getItem(PKEY)) return true; } catch (e) {}
    return /(?:^|;\s*)bdg_aniv_purchased=1/.test(document.cookie);
  }
  /* Se arma cuando la clienta aplica/copia su cupón. */
  function arm() { try { localStorage.setItem(AKEY, '1'); localStorage.removeItem(HKEY); } catch (e) {} }
  function isArmed() { try { return !!localStorage.getItem(AKEY); } catch (e) { return false; } }
  function setPurchased() { try { localStorage.setItem(PKEY, '1'); localStorage.removeItem(AKEY); localStorage.removeItem(HKEY); } catch (e) {} }

  /* ---- estado de la burbuja en localStorage ---- */
  function readBub() { try { return JSON.parse(localStorage.getItem(BKEY) || 'null'); } catch (e) { return null; } }
  function writeBub(o) { try { localStorage.setItem(BKEY, JSON.stringify(o)); } catch (e) {} }
  function clearBub() { try { localStorage.removeItem(BKEY); } catch (e) {} }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    var overlay = document.getElementById('bdgan-overlay');
    if (!overlay) return;

    if (forced()) { clearBub(); }

    var card = document.getElementById('bdgan-card');
    var s1 = document.getElementById('bdgan-step1');
    var s2 = document.getElementById('bdgan-step2');
    var scene = document.getElementById('bdgan-scene');
    var scard = document.getElementById('bdgan-scard');
    var cv = document.getElementById('bdgan-foil');
    var fx = document.getElementById('bdgan-fx');
    var glow = document.getElementById('bdgan-glow');
    var rDisc = document.getElementById('bdgan-disc');
    var rPhrase = document.getElementById('bdgan-phrase');
    var hint = document.getElementById('bdgan-hint');
    var after = document.getElementById('bdgan-after');
    var bubble = document.getElementById('bdgan-bubble');
    var ctx = cv.getContext('2d'), fxc = fx.getContext('2d');
    var W = cv.width, H = cv.height;
    var cur, scratching = false, done = false, moved = 0, subscribed = false;

    /* ---- abrir / cerrar ---- */
    function open() { overlay.classList.add('bdgan-on'); document.body.style.overflow = 'hidden'; }
    function close() {
      overlay.classList.remove('bdgan-on'); document.body.style.overflow = ''; mark();
      if (done) setBubble('post');
      else if (subscribed && cur) setBubble('card');
      else setBubble('pre');
    }
    document.getElementById('bdgan-close').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.classList.contains('bdgan-on')) close(); });

    if (forced()) { setTimeout(open, 300); }
    else if (shouldShow() && !readBub()) { setTimeout(function () { if (shouldShow()) open(); }, DELAY_MS); }

    /* ---- burbuja persistente ---- */
    function showBubble(rec) {
      if (!bubble || !rec) return;
      bubble.setAttribute('data-state', rec.kind === 'post' ? 'post' : 'pre');
      if (rec.kind === 'post') {
        var pctTxt = rec.d + '%', code = rec.code || ('BDG8-' + rec.d);
        var de = bubble.querySelectorAll('[data-disc]'); for (var i = 0; i < de.length; i++) de[i].textContent = pctTxt;
        var ce = bubble.querySelectorAll('[data-code]'); for (var j = 0; j < ce.length; j++) ce[j].textContent = code;
      }
      bubble.hidden = false;
    }
    function setBubble(kind) {
      var prev = readBub();
      var until = (prev && prev.until && prev.until > Date.now()) ? prev.until : (Date.now() + BUBBLE_MS);
      var o = { kind: kind, until: until };
      if (kind === 'post' || kind === 'card') { if (cur) { o.d = cur.d; o.m = cur.m; o.code = CODES[cur.d] || ('BDG8-' + cur.d); } }
      writeBub(o); showBubble(o);
    }

    /* Detecta compra sin tocar el checkout: si la clienta aplico su cupon (armado) y su
       carrito paso de tener productos a quedar vacio, asumimos compra completada. */
    function checkCartForPurchase() {
      if (!isArmed()) return;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var n = (c && typeof c.item_count === 'number') ? c.item_count : 0;
          if (n > 0) { try { localStorage.setItem(HKEY, '1'); } catch (e) {} return; }
          var had = false; try { had = !!localStorage.getItem(HKEY); } catch (e) {}
          if (had) { setPurchased(); clearBub(); if (bubble) bubble.hidden = true; }
        })
        .catch(function () {});
    }

    /* ---- restaurar pasos al reabrir desde la burbuja ---- */
    function resetStep1() { done = false; after.hidden = true; s2.hidden = true; s1.hidden = false; }
    function applyShopHref(code) { var b = document.getElementById('bdgan-shop'); if (b && code) b.href = '/discount/' + code + '?redirect=/collections/all'; }
    function restoreCard(rec) {
      cur = { d: rec.d, m: rec.m || msgFor(rec.d) }; done = false; subscribed = true;
      s1.hidden = true; s2.hidden = false; after.hidden = true;
      cv.style.display = ''; cv.style.opacity = '1'; hint.style.display = '';
      setCard(cur); drawFoil();
    }
    function restoreRevealed(rec) {
      cur = { d: rec.d, m: rec.m || msgFor(rec.d) }; done = true; subscribed = true;
      s1.hidden = true; s2.hidden = false;
      var codeTxt = rec.code || ('BDG8-' + rec.d);
      document.getElementById('bdgan-code').textContent = codeTxt; applyShopHref(codeTxt);
      rDisc.style.transition = 'none'; rDisc.textContent = rec.d + '%'; rDisc.style.opacity = '1'; rDisc.style.transform = 'scale(1)';
      rPhrase.textContent = cur.m; rPhrase.style.opacity = '1'; rPhrase.style.transform = 'translateY(0)';
      cv.style.display = 'none'; hint.style.display = 'none'; glow.style.opacity = '0'; after.hidden = false;
    }

    if (bubble) {
      var existing = readBub();
      if (purchased()) { clearBub(); bubble.hidden = true; }
      else {
        if (existing && pathOk() && !forced()) showBubble(existing);
        checkCartForPurchase();
      }

      bubble.addEventListener('click', function () {
        var rec = readBub();
        if (rec && rec.kind === 'post') restoreRevealed(rec);
        else if (rec && rec.kind === 'card') restoreCard(rec);
        else resetStep1();
        open();
      });
      bubble.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); bubble.click(); } });

      var bcopy = bubble.querySelector('.bdgan-bub-copy');
      if (bcopy) bcopy.addEventListener('click', function (e) {
        e.stopPropagation();
        var rec = readBub(); var code = (rec && rec.code) ? rec.code : '';
        if (navigator.clipboard && code) navigator.clipboard.writeText(code);
        arm();
        var b = this; b.textContent = 'COPIADO'; setTimeout(function () { b.textContent = 'COPIAR'; }, 1500);
      });
    }

    var shopBtn0 = document.getElementById('bdgan-shop');
    if (shopBtn0) shopBtn0.addEventListener('click', function () { arm(); });

    /* ---- captura de lead: Shopify (cliente + tags) + Klaviyo (lista Newsletter) ---- */
    function subscribe(name, email) {
      try {
        var fd = new FormData();
        fd.append('form_type', 'customer');
        fd.append('utf8', '✓');
        fd.append('contact[email]', email);
        fd.append('contact[first_name]', name);
        fd.append('contact[tags]', 'aniversario-8, popup-aniversario');
        fetch('/contact', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } }).catch(function () {});
      } catch (e) {}
      try {
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'BDG Popup Aniversario 8º',
                profile: { data: { type: 'profile', attributes: { email: email, first_name: name } } }
              },
              relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST } } }
            }
          })
        }).catch(function () {});
      } catch (e) {}
    }

    /* ---- foil ---- */
    function drawFoil() {
      ctx.globalCompositeOperation = 'source-over'; ctx.clearRect(0, 0, W, H);
      var g = ctx.createLinearGradient(0, 0, W, H);
      g.addColorStop(0, '#C49C55'); g.addColorStop(.45, '#E3C57E'); g.addColorStop(.55, '#D8B86B'); g.addColorStop(1, '#B68B42');
      ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
      ctx.strokeStyle = 'rgba(255,255,255,.16)'; ctx.lineWidth = 10;
      for (var i = -H; i < W; i += 30) { ctx.beginPath(); ctx.moveTo(i, H); ctx.lineTo(i + H, 0); ctx.stroke(); }
      for (var k = 0; k < 46; k++) { var sx = (k * 97) % W, sy = (k * 53) % H; ctx.fillStyle = 'rgba(255,255,255,' + (0.10 + (k % 4) * 0.05) + ')'; ctx.beginPath(); ctx.arc(sx, sy, (k % 3) + 1, 0, 7); ctx.fill(); }
      ctx.strokeStyle = 'rgba(120,90,30,.4)'; ctx.lineWidth = 1.5; ctx.strokeRect(7, 7, W - 14, H - 14);
      ctx.fillStyle = '#6B5018'; ctx.textAlign = 'center';
      ctx.font = '600 18px "Archivo Narrow", sans-serif'; ctx.fillText('RASPA AQUÍ', W / 2, H / 2 - 3);
      ctx.font = '12px "Archivo", sans-serif'; ctx.fillText('tu regalo te espera', W / 2, H / 2 + 19);
    }
    function setCard(x) {
      cur = x; rDisc.textContent = '0%'; rDisc.style.transition = 'none'; rDisc.style.transform = 'scale(.35)'; rDisc.style.opacity = '0';
      rPhrase.textContent = x.m; rPhrase.style.opacity = '0'; rPhrase.style.transform = 'translateY(6px)'; glow.style.opacity = '0';
    }
    function pt(e) { var r = cv.getBoundingClientRect(); return { x: (e.clientX - r.left) * (W / r.width), y: (e.clientY - r.top) * (H / r.height) }; }
    function erase(x, y) { ctx.globalCompositeOperation = 'destination-out'; ctx.beginPath(); ctx.arc(x, y, 21, 0, 7); ctx.fill(); }
    function pct() { var d = ctx.getImageData(0, 0, W, H).data, n = 0, t = 0; for (var i = 3; i < d.length; i += 80) { t++; if (d[i] < 128) n++; } return n / t; }

    /* ---- partículas ---- */
    var parts = [], t0 = null, ox = 0, oy = 0;
    function star(c, s) { c.beginPath(); for (var i = 0; i < 8; i++) { var a = Math.PI / 4 * i, rad = i % 2 ? s * .42 : s; c.lineTo(Math.cos(a) * rad, Math.sin(a) * rad); } c.closePath(); c.fill(); }
    var COLS = ['#C19A53', '#E3C57E', '#9A772F', '#F2E2B8', '#FCF8EE'];
    function launch() { parts = []; for (var i = 0; i < 80; i++) { var a = Math.random() * Math.PI * 2, sp = 2 + Math.random() * 9; parts.push({ x: ox, y: oy, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - 3, rot: Math.random() * 6, vr: (Math.random() - .5) * .5, sz: 3 + Math.random() * 5, col: COLS[i % 5], type: i % 3, life: 60 + Math.random() * 45 }); } t0 = null; requestAnimationFrame(fxFrame); }
    function fxFrame(now) {
      if (!t0) t0 = now; var el = now - t0; fxc.clearRect(0, 0, fx.width, fx.height);
      for (var ri = 0; ri < 3; ri++) { var rt = el - ri * 110; if (rt > 0 && rt < 620) { var rr = rt * .52, al = (1 - rt / 620) * .5; fxc.strokeStyle = 'rgba(200,160,90,' + al + ')'; fxc.lineWidth = 2; fxc.beginPath(); fxc.arc(ox, oy, rr, 0, 7); fxc.stroke(); } }
      var alive = false;
      for (var j = 0; j < parts.length; j++) { var p = parts[j]; if (p.life <= 0) continue; alive = true; p.vy += .13; p.vx *= .992; p.x += p.vx; p.y += p.vy; p.rot += p.vr; p.life--; fxc.save(); fxc.translate(p.x, p.y); fxc.rotate(p.rot); fxc.globalAlpha = Math.max(0, Math.min(1, p.life / 40)); fxc.fillStyle = p.col; if (p.type === 0) { fxc.fillRect(-p.sz / 2, -p.sz * .8, p.sz, p.sz * 1.6); } else if (p.type === 1) { star(fxc, p.sz); } else { fxc.beginPath(); fxc.arc(0, 0, p.sz * .6, 0, 7); fxc.fill(); } fxc.restore(); }
      if (el < 1500 && (alive || el < 700)) requestAnimationFrame(fxFrame); else fxc.clearRect(0, 0, fx.width, fx.height);
    }
    function countUp(to) { var st = null, dur = 850; function cu(now) { if (!st) st = now; var t = Math.min((now - st) / dur, 1), e = 1 - Math.pow(1 - t, 3); rDisc.textContent = Math.round(to * e) + '%'; if (t < 1) requestAnimationFrame(cu); else rDisc.textContent = to + '%'; } requestAnimationFrame(cu); }

    function finish() {
      if (done) return; done = true; mark();
      var codeTxt = CODES[cur.d] || ('BDG8-' + cur.d);
      document.getElementById('bdgan-code').textContent = codeTxt; applyShopHref(codeTxt);
      fx.width = card.clientWidth; fx.height = card.clientHeight;
      var r1 = scene.getBoundingClientRect(), r0 = card.getBoundingClientRect();
      ox = r1.left - r0.left + r1.width / 2; oy = r1.top - r0.top + r1.height * .46;
      cv.style.transition = 'opacity .5s'; cv.style.opacity = '0'; hint.style.display = 'none';
      scard.style.transition = 'transform .5s cubic-bezier(.2,1.4,.4,1)'; scard.style.transform = 'scale(1.04)';
      setTimeout(function () { scard.style.transform = 'scale(1)'; }, 500);
      setTimeout(function () {
        glow.style.opacity = '1'; launch();
        rDisc.style.transition = 'transform .65s cubic-bezier(.2,1.5,.35,1),opacity .4s'; rDisc.style.transform = 'scale(1)'; rDisc.style.opacity = '1'; countUp(cur.d);
        rPhrase.style.opacity = '1'; rPhrase.style.transform = 'translateY(0)';
      }, 260);
      setTimeout(function () { cv.style.display = 'none'; after.hidden = false; glow.style.transition = 'opacity 1s'; glow.style.opacity = '0'; }, 1150);
      setBubble('post');
    }

    cv.addEventListener('pointerdown', function (e) { if (done) return; scratching = true; cv.style.cursor = 'grabbing'; var p = pt(e); erase(p.x, p.y); });
    cv.addEventListener('pointermove', function (e) { if (!scratching || done) return; var p = pt(e); erase(p.x, p.y); moved++; if (moved % 6 === 0 && pct() > 0.5) finish(); });
    window.addEventListener('pointerup', function () { if (!scratching) return; scratching = false; cv.style.cursor = 'grab'; if (!done && pct() > 0.45) finish(); });

    document.getElementById('bdgan-go').addEventListener('click', function () {
      var nm = document.getElementById('bdgan-nm').value.trim();
      var em = document.getElementById('bdgan-em').value.trim();
      var err = document.getElementById('bdgan-err');
      if (nm.length < 2) { err.textContent = 'Dinos tu nombre.'; return; }
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em)) { err.textContent = 'Revisa tu correo.'; return; }
      err.textContent = '';
      subscribe(nm, em); subscribed = true;
      document.getElementById('bdgan-welcome').textContent = nm + ', tu tarjeta llegó. Ráspala.';
      s1.hidden = true; s2.hidden = false; setCard(pick()); drawFoil(); setBubble('card');
    });

    document.getElementById('bdgan-copy').addEventListener('click', function () {
      var t = document.getElementById('bdgan-code').textContent;
      if (navigator.clipboard) navigator.clipboard.writeText(t);
      arm();
      this.textContent = 'Copiado'; var b = this; setTimeout(function () { b.textContent = 'Copiar'; }, 1500);
    });
  });
})();
